import { ConvencaoJurosFixo } from "common/genericTypes";

export function convencaoJurosDescritivo(taxa: ConvencaoJurosFixo): string {
    switch (taxa) {
        case ConvencaoJurosFixo.Actual30_360:
            return 'Taxa anual, considerando que todos os meses possuem 30 dias exatos e, desta forma, o ano teria 360 dias.'
        case ConvencaoJurosFixo.Actual360:
            return 'Taxa anual, considerando os dias corridos entre as datas de pagamento, mas assumindo que todos os anos possuem 12 meses com 30 dias totalizando, portanto, 360 dias.'
        case ConvencaoJurosFixo.Actual365:
            return 'Taxa anual, considerando os dias corridos entre as datas de pagamento e assumindo que todos os anos possuem 365 dias - ou seja, desconsidera-se os anos bissextos.'
        case ConvencaoJurosFixo.Business252:
            return 'Taxa anual, considerando os dias úteis entre as datas de pagamento, mas assumindo que todos os anos possuem 12 meses com 21 dias úteis totalizando, portanto, 252 idas úteis.'
        case ConvencaoJurosFixo.Month_30:
            return 'Taxa mensal, considerando os dias corridos entre as datas de pagamento, mas assumindo que todos os meses possuem 30 dias exatos'
        case ConvencaoJurosFixo._30dc:
            return 'Taxa mensal, considerando que todos os meses possuem 30 dias exatos.'

        default:
            return 'Selecione a convenção';
    }
}